import React from 'react'
import './brand.css';
import { tiv, nicole, mowt } from './imports';


const brand = () => {
  return (
    <div className='taasa__brand section__padding'>
      <p>Trusted by humans from:</p>
      <div className="taasa__brand-image-container">
        <img className="taasa__brand-image" src={tiv} alt='tiv' />
      
      </div>
      <div className="taasa__brand-image-container">
      <img className="taasa__brand-image" src={mowt} alt='Ministry Of Works and Transport' />
      </div>
      <div className="taasa__brand-image-container">
      <img className="taasa__brand-image" src={nicole} alt='nicole foundation logo' />
      </div>
    </div>
  )
}

export default brand